module.exports = __webpack_public_path__ + "img/icon_shuju@2x.d25ee232.png";